import * as React           from 'react'
import { FormattedMessage } from 'react-intl'

import DialogActions  from '@material-ui/core/DialogActions/DialogActions'
import DialogContent  from '@material-ui/core/DialogContent'
import DialogTitle    from '@material-ui/core/DialogTitle'
import { withFormik } from 'formik'

import { ActionButton, InlineError, LoadingOverlay } from '../atoms'
import SessionScheduleChunk                          from './chunks/SessionScheduleChunk'
import { genValueMapper, proxyFormikSubmission }     from './form-utils'
import { emptySchedule, scheduleSchema }             from './schemas'
import { AppointmentFields }                         from './types'

export default withFormik<any, AppointmentFields>({
  mapPropsToValues: genValueMapper(emptySchedule),
  validationSchema: scheduleSchema,
  handleSubmit:     proxyFormikSubmission,
})(
  props => {
    const {
      handleSubmit,
      communication:
        {
          error,
          fetching,
        },
    } = props

    return (
      <LoadingOverlay show={fetching}>
        <form onSubmit={handleSubmit}>
          <DialogTitle>
            <FormattedMessage
              id={'generic.scheduleAppointmentPrompt'}
              defaultMessage={'Schedule your next appointment'}
            />
          </DialogTitle>
          <DialogContent>
            <SessionScheduleChunk {...props} />
          </DialogContent>
          {
            error && (
              <DialogContent>
                <InlineError i18nErrorId={error} />
              </DialogContent>
            )
          }
          <DialogActions>
            <ActionButton
              type={'submit'}
              actionType={'submit'}
              color={'primary'}
            />
          </DialogActions>
        </form>
      </LoadingOverlay>
    )
  },
)



// WEBPACK FOOTER //
// ./src/components/forms/SessionScheduleForm.tsx